import React, { useState } from "react";
import "../../Css/UserUpdate.css";





function UserUpdate() {
  const [user, setUser] = useState({
    nome: "",
    email: "",
    telefone: "",
    bi: "",
    endereco: "",
    cidade: "",
    visa: "",
    validade: "",
    iban: "",
    referencia: ""
  });

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    alert("Dados atualizados com sucesso!");
    // Aqui podes ligar ao Firebase / API
  };

  return (
    <div className="settingsPage">
      <h2 className="settingsTitle">Definições do Usuário</h2>

      {/* Dados Pessoais */}
      <section className="settingsCard">
        <h3>Identidade Pessoal</h3>

        <div className="grid">
          <input name="nome" placeholder="Nome Completo" onChange={handleChange} />
          <input name="email" placeholder="Email" onChange={handleChange} />
          <input name="telefone" placeholder="Telefone" onChange={handleChange} />
          <input name="bi" placeholder="Nº do BI" onChange={handleChange} />
        </div>
      </section>

      {/* Morada */}
      <section className="settingsCard">
        <h3>Morada de Entrega</h3>

        <div className="grid">
          <input name="endereco" placeholder="Endereço" onChange={handleChange} />
          <input name="cidade" placeholder="Cidade / Município" onChange={handleChange} />
        </div>
      </section>

      {/* Pagamentos */}
      <section className="settingsCard">
        <h3>Dados de Pagamento</h3>

        <div className="paymentTabs">
          <div className="paymentBox">
            <h4>Cartão Visa</h4>
            <input name="visa" placeholder="Número do Cartão" onChange={handleChange} />
            <input name="validade" placeholder="Validade MM/AA" onChange={handleChange} />
          </div>

          <div className="paymentBox">
            <h4>Transferência IBAN</h4>
            <input name="iban" placeholder="IBAN" onChange={handleChange} />
          </div>

          <div className="paymentBox">
            <h4>Referência / PayPay</h4>
            <input name="referencia" placeholder="Código de Referência" onChange={handleChange} />
          </div>
        </div>
      </section>

      <button className="saveBtn" onClick={handleSave}>
        Guardar Alterações
      </button>
    </div>
  );
}

export default UserUpdate;
